<template>
<div class="statisticalChartsContainer">
  <div class="chartItem">
    <div class="itemBox">
      <div class="chartBox">
        <echarts :chart-id="idName" :chart-option="options"></echarts>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: {
    flag: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      options: {
        // backgroundColor: '#42546c',
        backgroundColor: 'rgba(29, 55, 82, 0.85)',
        title: {
          // text: '多线图',
          textStyle: {
            align: 'center',
            color: '#fff',
            fontSize: 20,
          },
          top: '5%',
          left: 'center',
        },
        legend: {
          type: "plain",
          top: "2%",
          right: "2%",
          textStyle: {
            fontSize: 14
          },
          itemGap: 10,
          itemWidth: 20,
          itemHeight: 10,
          data: [{
              name: '报警',
              textStyle: {
                color: "#fff"

              }
            },
            {
              name: '故障',
              textStyle: {
                color: "#fff"
              }
            }
          ]
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(0, 255, 233,0)'
                }, {
                  offset: 0.5,
                  color: 'rgba(255, 255, 255,1)',
                }, {
                  offset: 1,
                  color: 'rgba(0, 255, 233,0)'
                }],
                global: false
              }
            },
          },
        },
        grid: {
          top: '20%',
          left: '6%',
          right: '6%',
          bottom: '15%',
          // containLabel: true
        },
        xAxis: [{
          type: 'category',
          axisLine: {
            show: true
          },
          splitArea: {
            // show: true,
            color: '#f00',
            lineStyle: {
              color: '#f00'
            },
          },
          axisLabel: {
            color: '#fff'
          },
          splitLine: {
            show: false
          },
          boundaryGap: false,
          data: [this.fun_date(-6), this.fun_date(-5), this.fun_date(-4), this.fun_date(-3), this.fun_date(-2), this.fun_date(-1), this.fun_date(0)],

        }],

        yAxis: [{
          type: 'value',
          min: 0,
          // max: 140,
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.1)'
            }
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
            margin: 20,
            textStyle: {
              color: '#d1e6eb',

            },
          },
          axisTick: {
            show: false,
          },
        }],
        series: [{
            name: '报警',
            type: 'line',
            smooth: true, //是否平滑
            showAllSymbol: true,
            // symbol: 'image://./static/images/guang-circle.png',
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: {
              normal: {
                color: "#f53232",
                shadowColor: 'rgba(0, 0, 0, .3)',
                shadowBlur: 0,
                shadowOffsetY: 5,
                shadowOffsetX: 5,
              },
            },
            label: {
              show: true,
              position: 'top',
              textStyle: {
                color: '#f53232',
              }
            },
            itemStyle: {
              color: "#f53232",
              borderColor: "#fff",
              borderWidth: 3,
              shadowColor: 'rgba(0, 0, 0, .3)',
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            tooltip: {
              show: false
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(247,58,58,0.3)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(247,58,58,0)'
                  }
                ], false),
                shadowColor: 'rgba(247,58,58,0.9)',
                shadowBlur: 20
              }
            },
            data: [9, 11, 6, 8, 5, 2, 1]
          },
          {
            name: '故障',
            type: 'line',
            smooth: true, //是否平滑
            showAllSymbol: true,
            // symbol: 'image://./static/images/guang-circle.png',
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: {
              normal: {
                color: "#d89521",
                shadowColor: 'rgba(0, 0, 0, .3)',
                shadowBlur: 0,
                shadowOffsetY: 5,
                shadowOffsetX: 5,
              },
            },
            label: {
              show: true,
              position: 'top',
              textStyle: {
                color: '#d89521',
              }
            },

            itemStyle: {
              color: "#d89521",
              borderColor: "#fff",
              borderWidth: 3,
              shadowColor: 'rgba(0, 0, 0, .3)',
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            tooltip: {
              show: false
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(216,149,33,0.3)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(216,149,33,0)'
                  }
                ], false),
                shadowColor: 'rgba(216,149,33,0.9)',
                shadowBlur: 20
              }
            },
            data: [15, 19, 21, 18, 22, 15, 12],
          },
        ]
      }
    }
  },
 /*  //数据自动刷新，必然需要一个监听机制告诉Echarts重新设置数据
  watch: {
    //观察option的变化
    options: {
      handler(newVal, oldVal) {
        if (this.myChart1) {
          if (newVal) {
            this.myChart1.setOption(newVal);
          } else {
            this.myChart1.setOption(oldVal);
          }
        } else {
          this.init();
        }
      },
      deep: true //对象内部属性的监听，关键。
    },
  }, */
/*   created() {
    console.log(this.options)
  },
  mounted() {}, */
  idName() {
    return this.flag ? "echartsId8_big" : "echartsId8"
  },
  methods: {
    fun_date(aa) {
      var date1 = new Date(),
        time1 = (date1.getMonth() + 1) + "-" + date1.getDate(); //time1表示当前时间
      var date2 = new Date(date1);
      date2.setDate(date1.getDate() + aa);
      var time2 = (date2.getMonth() + 1) + "-" + date2.getDate();
      return time2
    },
    init() {
      // 基于准备好的dom，初始化echarts实例
      let myChart1 = echarts.init(document.getElementById(this.idName))
      // console.log(myChart1)
      // 绘制图表，this.echarts1_option是数据
      myChart1.setOption(this.options, true)
    },
  }
}
</script>

<style lang="scss" scoped>
.statisticalChartsContainer {
  font-size: 0;
  text-align: center;
  overflow: hidden;
  width: 100%;
  height: 100%;

  .chartItem {
    width: 100%;
    height: 100%;

    .itemBox {
      width: 100%;
      height: 100%;

      .chartBox {
        width: 100%;
        height: 100%;
        background: rgba(29, 55, 82, 0.85);
      }
    }
  }
}
</style>
